module.exports = __webpack_public_path__ + "static/media/P1100019a.ca789c82.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/akopan/P1100019a.JPG
// module id = 33
// module chunks = 0